import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json'
import React from 'react'
import { Title } from 'src/viewLayer/components/DesignSystem'
import useViewport from 'src/viewLayer/components/hooks/useViewport'

import { ResponsiveHeaderStyled } from './index.styled'

const mediumBreakpoint = Number(tokens.viewports.breakpoints.medium.slice(0, -2))

export const ResponsiveHeader = ({
  changeBreakpoint = mediumBreakpoint,
  children,
  color,
  isCentered = true,
  largeSize = 'default',
  smallSize = 'small',
}) => {
  const viewport = useViewport()
  const headingSize = viewport < changeBreakpoint ? smallSize : largeSize

  return (
    <ResponsiveHeaderStyled isCentered={isCentered}>
      <Title color={color} size={headingSize} textAlign={isCentered && 'center'}>
        {children}
      </Title>
    </ResponsiveHeaderStyled>
  )
}
